module.exports = __webpack_public_path__ + "img/starthouse_signaturemenu_image16.57d66022.jpg";